import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=5c21f030&scoped=true&"
import script from "./FileDrop.vue?vue&type=script&lang=js&"
export * from "./FileDrop.vue?vue&type=script&lang=js&"
import style0 from "./FileDrop.vue?vue&type=style&index=0&id=5c21f030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21f030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\VS Projects\\SieTest E\\SieTest 4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c21f030')) {
      api.createRecord('5c21f030', component.options)
    } else {
      api.reload('5c21f030', component.options)
    }
    module.hot.accept("./FileDrop.vue?vue&type=template&id=5c21f030&scoped=true&", function () {
      api.rerender('5c21f030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/sietest/components/FileDrop.vue"
export default component.exports